import { Button } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconPlus } from '@tabler/icons-react';
import { TRPCClientError } from '@trpc/client';

import { trpc } from '../../../../../services/trpc';
import { UploadQuoteForm } from './-upload-quote-form';

interface UploadQuoteButtonProps {
  projectId: string;
  label?: string;
  icon?: React.ReactNode;
}

export function UploadQuoteButton({
  projectId,
  label = 'Ajouter un document',
  icon = <IconPlus size={16} />,
}: UploadQuoteButtonProps) {
  const addDocument = trpc.documents.uploadQuote.useMutation();

  const openAddDocumentModal = () => {
    modals.open({
      title: label,
      children: (
        <UploadQuoteForm
          projectId={projectId}
          onSubmit={async values => {
            try {
              await addDocument.mutateAsync({
                projectId,
                utFileKey: values.utFileKey,
                fileName: values.fileName,
              });
              notifications.show({
                title: 'Document ajouté avec succès',
                message: '',
                color: 'green',
              });
            } catch (e) {
              notifications.show({
                title: 'Erreur',
                message:
                  e instanceof TRPCClientError
                    ? e.message
                    : "Erreur lors de l'ajout du document",
                color: 'red',
              });
            } finally {
              modals.closeAll();
            }
          }}
        />
      ),
    });
  };

  return (
    <Button onClick={openAddDocumentModal} variant="outline" leftSection={icon}>
      {label}
    </Button>
  );
}
